import { Box, Stack } from "@mui/material";
import React from "react";
import { Color } from "../constants";
import { Inputs } from "../constants";
import ClearIcon from "@mui/icons-material/Clear";

const FettiChip = ({ value, ...props }) => {
  const [hovered, setHovered] = React.useState(false);
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        // backgroundColor: Color.fettiLightBlue,
        // backgroundColor: "#e0e0e0",
        borderRadius: "4px",
        padding: `${Inputs.py} ${Inputs.px}`,
        cursor: "pointer",
        border: !hovered
          ? `2px solid ${Color.fettiLightBlue}`
          : `2px solid ${Color.fettiLightBlue}`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}>
      <Box>{value}</Box>
      <ClearIcon
        sx={{
          fontSize: "14px",
          // color: Color.secondaryTextGray
          color: hovered ? "red" : Color.secondaryTextGray,
          transition: "color 0.2s ease-in-out",
        }}
      />
    </Stack>
  );
};

export default FettiChip;
